import { render, staticRenderFns } from "./page4.vue?vue&type=template&id=43218a08&scoped=true&"
import script from "./page4.vue?vue&type=script&lang=js&"
export * from "./page4.vue?vue&type=script&lang=js&"
import style0 from "./page4.vue?vue&type=style&index=0&id=43218a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43218a08",
  null
  
)

export default component.exports